import { type Enterprise } from '@avanta/shared/types/enterprises';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from 'constants/common';
import { EnterprisesService } from 'services/enterprises';

export const useFetchEnterprise = ({
  enterpriseId,
  isProfileSetup,
}: {
  enterpriseId: string | null | undefined;
  isProfileSetup?: boolean;
}): UseQueryResult<Enterprise | null> =>
  useQuery({
    queryKey: [QUERY_KEYS.FETCH_ENTERPRISE, enterpriseId],
    queryFn: () => EnterprisesService.getEnterpriseById(enterpriseId ?? ''),
    select: response => response.data,
    enabled: Boolean(enterpriseId) && !isProfileSetup,
  });
